export const customStyles = {
    input: (provided) => ({
        ...provided,
        "input:focus": {
            boxShadow: 'none',
        },
    }),
};

export const getMultiSelectValue = (fieldValue, optionsArray) => {
    if (!fieldValue || !Array.isArray(fieldValue) || fieldValue.length === 0) {
        return [];
    }
    return optionsArray?.filter(item => fieldValue.includes(item.id))
        .map(item => ({ value: item.id, label: item.name || item.reference })) || [];
};


export const handleMultiSelectChange = (selectedOptions, fieldName, formData, handleFormDataChange) => {
    const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
    handleFormDataChange({
        ...formData,
        [fieldName]: selectedIds,
    });
};


export const transformOptionsForSelect = (optionsArray) => {
    return optionsArray?.map(item => ({ value: item.id, label: item.name })) || [];
};


export const createPaginationState = (itemsPerPage = 50) => {
    return {
        currentPage: 1,
        searchTerm: '',
        itemsPerPage
    };
};

export const getVisibleOptions = (items, paginationState, filterProperty, valueProperty = 'id', labelProperty) => {
    const { currentPage, searchTerm, itemsPerPage } = paginationState;

    // Filter items based on search term
    const filteredItems = items?.filter(item =>
        item[filterProperty].toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

    // Return items up to current page
    const totalItems = currentPage * itemsPerPage;
    return filteredItems.slice(0, totalItems).map(item => ({
        value: item[valueProperty],
        label: item[labelProperty]
    }));
};


export const handleScrollToBottom = (items, paginationState, setPaginationState, filterProperty) => {
    const { currentPage, searchTerm, itemsPerPage } = paginationState;
    const filteredItems = items?.filter(item =>
        item[filterProperty].toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

    if (currentPage < totalPages) {
        setPaginationState(prev => ({
            ...prev,
            currentPage: prev.currentPage + 1
        }));
    }
};


export const handleInputChange = (inputValue, setPaginationState) => {
    setPaginationState(prev => ({
        ...prev,
        searchTerm: inputValue,
        currentPage: 1 // Reset to first page when searching
    }));
};
